import React, { useState } from "react";
import "react-simple-keyboard/build/css/index.css";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { login } from "../../services/redux/ApiActions";
import logoPng from "../../img/logo.png";
import PhoneInput from "../reusableComponents/PhoneInput";
import { Capacitor } from "@capacitor/core";
import showNotification from "../../services/redux/NotifcationService";
import ORComponent from "../Common/ORComponent";
import RecaptchaComponent from "../Common/RecaptchaComponent";
import Footer from "../Common/Footer";

const LoginWithPhone = () => {
  const [displayVirtualKeyboard, setDisplayVirtualKeyboard] = useState(false);
  const [phone, setPhone] = useState();
  const [recpatcha, setRecaptcha] = useState();
  const navigate = useNavigate();

  function onChangeCaptcha(value) {
    // console.log("Captcha value:", value);
    setRecaptcha(value);
  }

  const dispatch = useDispatch();
  const handleSubmit = async (event) => {
    event.preventDefault();
    const data = {
      email: phone,
      password: "",
      code: "",
      isOtpNeeded: true,
      recaptchaValue: recpatcha,
    };
    if (phone === undefined) {
      showNotification("Phone Number Field cannot be empty", "error");
    } else if (phone.length !== 10) {
      showNotification("Phone Number must be of 10 digits", "error");
    } else if (recpatcha === undefined) {
      showNotification("Captcha verification is required", "error");
    } else {
      const response = await dispatch(login(data));
      if (response) {
        // console.log(response);
        showNotification(response.message, "success");
        const postedData = {
          email: phone,
          password: "",
          screen: "phone",
          userId: response.userId,
        };
        navigate("/otp", { state: { postedData } });
      }
    }
  };
  const handleChange = (e) => {
    const value = e.target.value.slice(0, 10);
    const sanitizedValue = value.replace(/\D/g, "");
    setPhone(sanitizedValue);
  };
  return (
    <div className="mailsentbody">
      <div className="logoBG">
        <div className="rightElement">
          <div className="flex min-h-full flex-col justify-center px-6 py-10 lg:px-8">
            <div
              style={{
                backgroundColor: `${Capacitor.isNative === true ? "transparent" : "white"}`,
                padding: `${Capacitor.isNative === true ? "5px" : "20px"}`,
              }}
              className="rounded-lg  mt-5 sm:mx-auto sm:w-full md:max-w-md lg:max-w-lg"
            >
              <div className="space-y-6">
                <div>
                  <div className="sm:mx-auto sm:w-full sm:max-w-sm">
                    <img
                      className="mx-auto h-10 w-auto"
                      src={logoPng}
                      alt="Your Company"
                    />
                  </div>
                  <h2 className="pb-2 text-center text-xl font-bold leading-9 tracking-tight text-gray-900">
                    STAFF LOGIN
                  </h2>
                  <p className="pb-2 text-md text-center text-gray-500">
                    Kindly enter your mobile number
                  </p>
                  <label
                    htmlFor="email"
                    className="block text-md font-medium leading-6 text-gray-900"
                  >
                    Mobile Number
                  </label>
                  <div className="mt-2">
                    <PhoneInput
                      value={phone || ""}
                      onChange={handleChange}
                      inputStyles={{
                        paddingLeft: "10px",
                        padding: "15px 10px",
                      }}
                    />
                  </div>
                </div>
                <RecaptchaComponent onChangeCaptcha={onChangeCaptcha} />
                <div>
                  <center>
                    <button
                      onClick={handleSubmit}
                      className="flex w-10/12 justify-center rounded-md  px-3 py-1.5 text-sm font-semibold leading-6 text-white shadow-sm focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2"
                      style={{ backgroundColor: "#2E61A2" }}
                    >
                      Proceed
                    </button>
                  </center>
                </div>
              </div>
              <ORComponent />
              <div className="flex justify-center">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  strokeWidth={1.5}
                  stroke="currentColor"
                  className="w-6 h-6"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M10.5 1.5H8.25A2.25 2.25 0 0 0 6 3.75v16.5a2.25 2.25 0 0 0 2.25 2.25h7.5A2.25 2.25 0 0 0 18 20.25V3.75a2.25 2.25 0 0 0-2.25-2.25H13.5m-3 0V3h3V1.5m-3 0h3m-3 18.75h3"
                  />
                </svg>
                <Link
                  to="/"
                  className=" text-base font-semibold leading-6 text-indigo-600 hover:text-indigo-500"
                >
                  Login with email and password
                </Link>
              </div>
            </div>
            <Footer />
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoginWithPhone;
